import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {PopoverInfo} from 'shells/popover-info/popover-info';

const CONTACTS_OVERAGE_COPY = (
    <div className='flex align-center'>
        Overages enabled
        <PopoverInfo info='Overages are enabled for your account. You will be billed for any contacts used over the total included with your monthly plan.' />
    </div>
);

export function getContactsMessage(
    contactsCount: number,
    contactsMax: number,
    hasOveragesEnabledFromWebfx: boolean
): string | React.ReactNode {
    if (hasOveragesEnabledFromWebfx) {
        return CONTACTS_OVERAGE_COPY;
    }

    if (contactsCount >= contactsMax) {
        return `You’ve reached your current limit of ${contactsMax.toLocaleString()} contacts.`;
    }

    const percentComplete = contactsCount / contactsMax;
    const remainingContacts = contactsMax - contactsCount;

    if (percentComplete >= 0.95) {
        return `You can only add ${remainingContacts.toLocaleString()} more ${
            remainingContacts === 1 ? 'contact' : 'contacts'
        } in your current tier.`;
    }

    return `You can add ${remainingContacts.toLocaleString()} more ${
        remainingContacts === 1 ? 'contact' : 'contacts'
    } in your current tier.`;
}

export function getUniqueSendsMessage(
    sendsCount: number,
    sendsMax: number,
    hasOveragesEnabledFromWebfx: boolean
): string | React.ReactNode {
    if (hasOveragesEnabledFromWebfx) {
        return CONTACTS_OVERAGE_COPY;
    }

    if (sendsCount >= sendsMax) {
        return `You’ve reached your current send limit of ${sendsMax.toLocaleString()} contacts.`;
    }

    const percentComplete = sendsCount / sendsMax;
    const remainingSends = sendsMax - sendsCount;

    if (percentComplete >= 0.95) {
        return `You can only send to ${remainingSends.toLocaleString()} more ${
            remainingSends === 1 ? 'contact' : 'contacts'
        } this month.`;
    }

    return `You can send to ${remainingSends.toLocaleString()} more ${
        remainingSends === 1 ? 'contact' : 'contacts'
    } this month.`;
}

export function getEmailsCountMessage(emailsCount: number, emailsMax: number): string {
    if (emailsCount >= emailsMax) {
        return `You’ve sent all ${emailsMax.toLocaleString()} of your marketing emails this month.`;
    }

    const percentComplete = emailsCount / emailsMax;
    const remainingEmails = emailsMax - emailsCount;

    if (percentComplete === 0) {
        return `You can send ${remainingEmails.toLocaleString()} free marketing ${
            remainingEmails === 1 ? 'email' : 'emails'
        } this month.`;
    }

    if (percentComplete >= 0.95) {
        return `You can only send ${remainingEmails.toLocaleString()} more free marketing ${
            remainingEmails === 1 ? 'email' : 'emails'
        } this month.`;
    }

    return `You can send ${remainingEmails.toLocaleString()} more free marketing ${
        remainingEmails === 1 ? 'email' : 'emails'
    } this month.`;
}

export function getProgressBarColor(percentComplete: number, approachingLimitAmount: number) {
    let color;
    if (percentComplete >= approachingLimitAmount && percentComplete < 1) {
        color = colors.yellow;
    } else if (percentComplete === 1) {
        color = colors.red;
    } else color = colors.grey;

    return color;
}
